import { render } from "./Dashboard.vue?vue&type=template&id=2dc52a8e&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2dc52a8e"

export default script